export const itemContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const itemMetaGridStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px',
};

export const itemPayloadSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const itemMetadataSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const itemSummaryMetaStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const itemDividerStyles = {
  borderColor: ({ palette }) => palette.divider,
};

export { monospacePreStyles as itemMetadataPreStyles } from 'app/shared/styles/monospacePre.styles';
